import api from '@/plugins/api';
const DIRECTORY_PAGE_SIZE = 20;
export async function searchUserDirectory(search) {
    const response = await api.get('/users/directory', {
        params: { search, page: 1, pageSize: DIRECTORY_PAGE_SIZE },
    });
    return response.data.data.items;
}
